export default __webpack_public_path__ + "static/media/vrcarnaval_demo_image.cfbad3f9.png";